import { gsap } from 'gsap'

/**
 * ドロワーメニューの開閉機能
 */
export class Drawer {
  constructor() {
    this.hamburger = document.getElementById('js-hamburger')
    this.drawer = document.getElementById('js-drawer')
    if (this.hamburger === null || this.drawer === null) return
    this.drawerLinks = this.drawer.querySelectorAll('a')

    this.hamburger.addEventListener('click', () => {
      this.hamburger.querySelector('span').classList.toggle('hidden')
      this.hamburger.classList.toggle('is-act')

      if (this.hamburger.classList.contains('is-act')) {
        this.animation(this.drawer, 'open')
      } else {
        this.animation(this.drawer, 'close')
      }
    })

    this.drawerLinks.forEach((elm) => {
      elm.addEventListener('click', () => {
        this.animation(this.drawer, 'close')
        this.hamburger.querySelector('span').classList.toggle('hidden')
        this.drawer.classList.remove('is-act')
        this.hamburger.classList.remove('is-act')
      })
    })
  }
  animation(el, type) {
    if (type == 'open') {
      gsap.to(el, 0.3, { autoAlpha: 1, display: 'block' })
    } else {
      gsap.to(el, 0.3, { autoAlpha: 0, display: 'none' })
    }
  }
}
